import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15%;
  width: 100%;
  height: 100%;
`;
